/*eslint-disable import/default*/

import React from 'react';
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux';
import { HashRouter, Route, Link } from 'react-router-dom';
import './styles/bootstrap.css';
import './styles/styles.scss';
import App from './components/App';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';

const container = document.getElementById('app');
const root = createRoot(container);

root.render(<App />);
